import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';

import { DialogResult } from '..';
import { DialogConfigTyped, DialogTranslations } from '../config';

export class DialogConfigService {
  static buildMatDialogConfig<T>(
    config: DialogConfigTyped<T>
  ): MatDialogConfig<DialogConfigTyped<T>> {
    const panelClasses: string[] = [config.dialogType, 'mw-dialog'];

    if (config?.isFlexHeight !== false) {
      panelClasses.push('mw-flex-height');
    }

    const dialogConfig: MatDialogConfig<DialogConfigTyped<T>> = {
      panelClass: panelClasses,
      data: config,
      height: config.height,
      maxHeight: config.maxHeight,
      viewContainerRef: config.viewContainerRef,
      disableClose:
        config.disableClose !== undefined ? config.disableClose : false,
      hasBackdrop: config.hasBackdrop !== undefined ? config.hasBackdrop : true,
      backdropClass: config.backdropClass,
      autoFocus:
        config.autoFocus !== undefined
          ? config.autoFocus
          : '.confirm-btn button',
      restoreFocus:
        config.restoreFocus !== undefined ? config.restoreFocus : false,
    };

    if (config?.dialogType === 'mw-dialog-full-screen') {
      dialogConfig.width =
        dialogConfig.height =
        dialogConfig.maxHeight =
        dialogConfig.maxWidth =
          '100%';
    }

    return dialogConfig;
  }

  static buildConfirmDialogTranslations(config?: {
    translations?: DialogTranslations;
    showTitle?: boolean;
    showMsg?: boolean;
    singleButton?: boolean;
  }): DialogTranslations {
    return {
      title:
        config?.showTitle !== false
          ? config?.translations?.title || 'CORE.COMPONENT.CONFIRM.confirm'
          : null,
      text:
        config?.showMsg !== false
          ? config?.translations?.text || 'CORE.COMPONENT.CONFIRM.are_you_sure'
          : null,
      yesButton:
        config?.translations?.yesButton || 'CORE.COMPONENT.CONFIRM.yes',
      noButton:
        config?.singleButton === true
          ? null
          : config?.translations?.noButton || 'CORE.COMPONENT.CONFIRM.no',
    };
  }
  static buildConfirmDeleteDialogTranslations(config?: {
    text?: string;
    title?: string;
    yesButton?: string;
    noButton?: string;
    itemName?: string | ((result?: DialogResult) => string);
  }): DialogTranslations {
    const itemName =
      typeof config?.itemName === 'string'
        ? config.itemName
        : typeof config.itemName === 'function'
        ? config.itemName()
        : null;

    const itemParam = itemName ? { item: itemName } : null;

    const defaultText = config?.itemName
      ? 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.msg_with_params'
      : 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.msg';
    const defaultTitle = config?.itemName
      ? 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.title_with_params'
      : 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.title';
    return {
      text: config?.text || defaultText,
      text_params: itemParam,
      title: config?.title || defaultTitle,
      title_params: itemParam,
      yesButton:
        config?.yesButton || 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.confirm',
      noButton: 'CORE.COMPONENT.CONFIRM.DIALOG.DELETE.cancel',
    };
  }

  static buildModifyDialogTranslations(config: {
    translations?: DialogTranslations;
    isEditDialog?: boolean;
    itemName?: string | ((result?: DialogResult) => string);
  }): DialogTranslations {
    const itemName =
      typeof config?.itemName === 'string'
        ? config.itemName
        : typeof config.itemName === 'function'
        ? config.itemName()
        : null;

    const itemParam = itemName ? { item: itemName } : null;

    const defaultYesButton = config.isEditDialog
      ? 'CORE.COMPONENT.DIALOG.BUTTON.save'
      : config?.itemName
      ? 'CORE.COMPONENT.DIALOG.BUTTON.add_with_param'
      : 'CORE.COMPONENT.DIALOG.BUTTON.add';

    const defaultTitle = config?.itemName
      ? config.isEditDialog
        ? 'CORE.COMPONENT.DIALOG.edit_with_param'
        : 'CORE.COMPONENT.DIALOG.add_with_param'
      : config.isEditDialog
      ? 'CORE.COMPONENT.DIALOG.edit'
      : 'CORE.COMPONENT.DIALOG.add';

    return {
      title: defaultTitle,
      text_params: itemParam,
      yesButton: defaultYesButton,
      title_params: itemParam,
      noButton: 'CORE.COMPONENT.DIALOG.cancel',
      ...config.translations,
    };
  }
}
